import { AuthApi as BASE_URL } from '../api/config';

const AuthSvc = {
  isAuthenticated: async () => {
    const token = localStorage.getItem('authToken');
    if (!token) return false;

    try {
      const user = await AuthSvc.user(token);
      return user;
    } catch (err) {
      localStorage.removeItem("authToken");
      return false;
    }
  },

  login: async (credentials) => {
    const response = await fetch(`${BASE_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(credentials),
      credentials: "include"
    });

    if (!response.ok) {
      throw new Error("Login failed");
    }

    const data = await response.json();
    return {
      success: data.success,
      token: data.token,
      role: data.role
    };
  },

  user: async (token) => {
    const response = await fetch(`${BASE_URL}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      credentials: "include"
    });

    if (!response.ok) {
      throw new Error("Failed to fetch user data");
    }

    const data = await response.json();
    return {
      email: data.email,
      avatar: data.avatar
    };
  },

  logout: async (token) => {
    const response = await fetch(`${BASE_URL}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      credentials: "include"
    });

    if (!response.ok) {
      throw new Error("Logout failed");
    }

    return await response.json();
  }
};

export default AuthSvc;